(function () {
  'use strict';

  var PREORDER_LABEL = 'Pre-Order (ships in <3 days)';
  var NO_FIT = 'Nothing in this model fits those numbers — try a smaller measurement or another collection.';
  /** Live TGR collection (verified via Shopify CLI 2026-09-19). */
  var TGR_COLLECTION_PATH = '/collections/tgr';
  var TGR_TRAP_NOTE = 'Trapezoid sizing applies (catalog width > rear ≤ front).';
  var GR_TGR_HINT =
    'Trapezoid opening (front wider than back) — a TGR tapered grate often fits more tubes; see ' +
    TGR_COLLECTION_PATH;
  var syncing = false;
  /** Pinned variant id: manual menu pick or measure snap. Blocks Dawn bounce-to-default. */
  var pinnedVariantId = null;

  /** Families where tubes lean ~70°: Deep Top is N/A for scoring. */
  var SKIP_DEEP_TOP_RE = /(dgr|tgr|(?:^|[^a-z0-9])gr(?:$|[^a-z])|\dgr(?:$|-)|(?:^|-)(?:\d+)?gr(?:$|-)|(?:^|[^a-z0-9])(?:1q|2q|3q)(?:$|[^a-z])|\d*q\d*)/i;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function parseNum(v) {
    var n = parseFloat(String(v == null ? '' : v).replace(/[^\d.]/g, ''));
    return isFinite(n) ? n : null;
  }

  function skipsDeepTop(handle) {
    var h = String(handle || '').toLowerCase();
    if (!h) return false;
    if (h.indexOf('dgr') !== -1) return true;
    if (h.indexOf('tgr') !== -1) return true;
    if (/(?:^|-)(?:\d+)?gr(?:$|-)/.test(h)) return true;
    if (/\dgr(?:$|-)/.test(h)) return true;
    if (/(?:^|-)(?:\d*)?1q|(?:^|-)1q/.test(h) || /1q-/.test(h)) return true;
    if (/(?:^|-)(?:\d*)?2q|2q\d|2q-/.test(h)) return true;
    if (/(?:^|-)(?:\d*)?3q|3q\d|^3q$/.test(h)) return true;
    // bare family tokens in handle fragments like "14gr"
    if (/^\d*(?:tgr|dgr|gr)$/.test(h)) return true;
    if (/^\d*q/.test(h) && /q/.test(h)) return true;
    return false;
  }

  /**
   * Parse order-size dims from variant title/sku/options.
   * Returns { frontW, rearW, w, h, d, dMin, dMax } — only fields found in store data.
   */
  function parseDims(text) {
    var s = String(text || '');
    var frontW = null;
    var rearW = null;
    var w = null;
    var h = null;
    var d = null;
    var dMin = null;
    var dMax = null;
    var m;

    // TGR-style: 16" wide Front 14" wide Back 24" Tall/Deep
    m = s.match(/(\d+(?:\.\d+)?)\s*"?\s*wide\s*Front\s*(\d+(?:\.\d+)?)\s*"?\s*wide\s*Back/i);
    if (m) {
      frontW = +m[1];
      rearW = +m[2];
      w = rearW;
    }

    // Compact Q: 2Q16W14T16D / 243Q14T16D / 162Q14T14D
    m = s.match(/(\d*)Q(\d+(?:\.\d+)?)W(\d+(?:\.\d+)?)T(?:all)?(\d+(?:\.\d+)?)D/i);
    if (m) {
      if (w == null) w = +m[2];
      if (h == null) h = +m[3];
      if (d == null) d = +m[4];
    }

    // Spaced Q: Q 16 W 14 T 14 D
    m = s.match(/(?:\d+\s*)?Q\s*(\d+(?:\.\d+)?)\s*W\s*(\d+(?:\.\d+)?)\s*T(?:all)?\s*(\d+(?:\.\d+)?)\s*D/i);
    if (m) {
      if (w == null) w = +m[1];
      if (h == null) h = +m[2];
      if (d == null) d = +m[3];
    }

    // 24w 14t 14d / 8w 14d
    m = s.match(/(\d+(?:\.\d+)?)\s*w(?:ide)?\s*(\d+(?:\.\d+)?)\s*t(?:all)?\s*(\d+(?:\.\d+)?)\s*d/i);
    if (m) {
      if (w == null) w = +m[1];
      if (h == null) h = +m[2];
      if (d == null) d = +m[3];
    } else {
      m = s.match(/(\d+(?:\.\d+)?)\s*w(?:ide)?\s*(\d+(?:\.\d+)?)\s*d\b/i);
      if (m) {
        if (w == null) w = +m[1];
        if (d == null) d = +m[2];
      }
    }

    // 24W14T26D compact RC-style
    m = s.match(/\b(\d+(?:\.\d+)?)W(\d+(?:\.\d+)?)T(\d+(?:\.\d+)?)D\b/i);
    if (m) {
      if (w == null) w = +m[1];
      if (h == null) h = +m[2];
      if (d == null) d = +m[3];
    }

    // Depth range: 26"-32" Deep (DS)
    m = s.match(/(\d+(?:\.\d+)?)\s*"?\s*-\s*(\d+(?:\.\d+)?)\s*"?\s*Deep/i);
    if (m) {
      dMin = +m[1];
      dMax = +m[2];
      if (d == null) d = dMax;
    }

    // 14" Wide 20" Tall/Deep
    m = s.match(/(\d+(?:\.\d+)?)\s*"?\s*wide[\s\S]{0,40}?(\d+(?:\.\d+)?)\s*"?\s*tall\s*\/\s*deep/i);
    if (m) {
      if (w == null && frontW == null) w = +m[1];
      if (h == null) h = +m[2];
      if (d == null) d = +m[2];
    }

    // 14" Wide 16" Tall 14" Deep
    m = s.match(/(\d+(?:\.\d+)?)\s*"?\s*Wide\s+(\d+(?:\.\d+)?)\s*"?\s*Tall\s+(\d+(?:\.\d+)?)\s*"?\s*Deep/i);
    if (m) {
      if (w == null && frontW == null) w = +m[1];
      if (h == null) h = +m[2];
      if (d == null) d = +m[3];
    }

    var wide = s.match(/(\d+(?:\.\d+)?)\s*"?\s*wide(?!\s*Front|\s*Back)/i);
    var tallDeep = s.match(/(\d+(?:\.\d+)?)\s*"?\s*tall\s*\/\s*deep/i);
    var tall = s.match(/(\d+(?:\.\d+)?)\s*"?\s*tall(?!\s*\/)/i);
    var deep = s.match(/(\d+(?:\.\d+)?)\s*"?\s*deep/i);
    if (wide && w == null && frontW == null) w = +wide[1];
    if (tallDeep) {
      if (h == null) h = +tallDeep[1];
      if (d == null) d = +tallDeep[1];
    } else {
      if (tall && h == null) h = +tall[1];
      if (deep && d == null && dMax == null) d = +deep[1];
    }

    // NxNxN
    m = s.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)(?:\s*[x×]\s*(\d+(?:\.\d+)?))?/i);
    if (m && w == null && frontW == null) {
      w = +m[1];
      if (m[3]) {
        if (h == null) h = +m[2];
        if (d == null) d = +m[3];
      } else {
        if (h == null) h = +m[2];
        if (d == null) d = +m[2];
      }
    }

    // Compact TGR/DGR/GR: 14TGR14TD / 16GR20TD (family glued to depth)
    m = s.match(/(\d+(?:\.\d+)?)\s*(TGR|DGR|GR)(\d+(?:\.\d+)?)TD\b/i);
    if (m) {
      if (w == null && frontW == null) w = +m[1];
      if (h == null) h = +m[3];
      if (d == null) d = +m[3];
    }

    // Leading size before family code: 14TGR / 16GR / 8HTH
    m = s.match(/(\d+(?:\.\d+)?)\s*(TGR|DGR|HTH|GR|DS|RC|CHP)\b/i);
    if (m && w == null && frontW == null) w = +m[1];

    m = s.match(/(\d+(?:\.\d+)?)\s*TD\b/i);
    if (m) {
      if (h == null) h = +m[1];
      if (d == null) d = +m[1];
    } else {
      m = s.match(/(\d+(?:\.\d+)?)\s*D\b/i);
      if (m && d == null && dMax == null) {
        if (h == null) {
          h = +m[1];
          d = +m[1];
        } else {
          d = +m[1];
        }
      }
    }

    if (w != null && h != null && d == null) d = h;
    if (w != null && d != null && h == null) h = d;
    if (frontW != null && rearW != null && w == null) w = rearW;

    return { frontW: frontW, rearW: rearW, w: w, h: h, d: d, dMin: dMin, dMax: dMax };
  }

  function variantDims(v) {
    var parts = [v.title, v.sku];
    if (v.options && v.options.length) parts = parts.concat(v.options);
    return parseDims(parts.filter(Boolean).join(' '));
  }

  function isPreorder(v) {
    if (!v) return false;
    var qty = v.inventory_quantity;
    var qtyN = qty == null || qty === '' ? null : Number(qty);
    var policy = String(v.inventory_policy || '').toLowerCase();
    var mgmt = String(v.inventory_management || '').toLowerCase();
    if (policy === 'continue' && mgmt === 'shopify' && (qtyN == null || qtyN <= 0)) return true;
    if (v.available && mgmt === 'shopify' && qtyN != null && qtyN <= 0) return true;
    if (v.incoming && v.available && (qtyN == null || qtyN <= 0)) return true;
    return false;
  }

  function loadVariants(root) {
    if (!root) return [];
    var raw = root.getAttribute('data-variants');
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {}
    }
    var script = qs('script[type="application/json"][data-hh-variants]', root) || qs('#HhVariantsJson');
    if (script) {
      try {
        var fromScript = JSON.parse(script.textContent);
        if (Array.isArray(fromScript)) return fromScript;
      } catch (e2) {}
    }
    return [];
  }

  function modelSelect() {
    return qs('select.hh-model-select, select.model');
  }

  function optionSelects() {
    var vs = qs('variant-selects');
    if (!vs) return [];
    return qsa('select.select__select:not(.hh-model-select):not(.model)', vs);
  }

  function optionRadios() {
    var vs = qs('variant-selects');
    if (!vs) return [];
    return qsa('fieldset input[type="radio"]', vs);
  }

  function normalizeOptionText(v) {
    return String(v == null ? '' : v).replace(/\s+/g, ' ').trim();
  }

  function setSelectValue(sel, value) {
    if (!sel) return false;
    var want = String(value);
    var wantNorm = normalizeOptionText(value);
    var foundIdx = -1;
    var i;
    for (i = 0; i < sel.options.length; i++) {
      var ov = String(sel.options[i].value);
      if (ov === want || normalizeOptionText(ov) === wantNorm) {
        foundIdx = i;
        break;
      }
    }
    if (foundIdx < 0) return false;
    for (i = 0; i < sel.options.length; i++) {
      if (i === foundIdx) sel.options[i].setAttribute('selected', 'selected');
      else sel.options[i].removeAttribute('selected');
    }
    sel.selectedIndex = foundIdx;
    sel.value = sel.options[foundIdx].value;
    return true;
  }

  function findVariantById(variants, id) {
    var sid = String(id);
    for (var i = 0; i < (variants || []).length; i++) {
      if (String(variants[i].id) === sid) return variants[i];
    }
    return null;
  }

  function setIdInput(variantId) {
    var id = variantId == null ? '' : String(variantId);
    var seen = [];
    var nodes = qsa(
      'input.product-variant-id, form[data-type="add-to-cart-form"] input[name="id"], form[id^="product-form-"] input[name="id"], product-form input[name="id"]'
    );
    nodes.forEach(function (input) {
      if (!input || seen.indexOf(input) !== -1) return;
      seen.push(input);
      input.disabled = false;
      input.value = id;
    });
    syncShips();
  }

  /** HH 2026-10-06: keep hidden properties[_Ships] matched to the id input (assets/hh-ships.js). */
  function syncShips() {
    if (typeof window.hhShipsSync === 'function') {
      try {
        window.hhShipsSync();
      } catch (e) {}
    }
  }

  function collectSelectedOptionValueIds() {
    var vs = qs('variant-selects');
    if (!vs) return [];
    var ids = [];
    qsa('select', vs).forEach(function (sel) {
      var opt = sel.selectedOptions && sel.selectedOptions[0];
      if (opt && opt.dataset && opt.dataset.optionValueId) ids.push(opt.dataset.optionValueId);
    });
    qsa('fieldset input[type="radio"]:checked', vs).forEach(function (radio) {
      if (radio.dataset && radio.dataset.optionValueId) ids.push(radio.dataset.optionValueId);
    });
    return ids;
  }

  function syncDawnOptions(variant) {
    if (!variant) return;
    var opts = variant.options || [];
    var selects = optionSelects();
    var i;
    for (i = 0; i < selects.length && i < opts.length; i++) {
      setSelectValue(selects[i], String(opts[i]));
    }
    var radios = optionRadios();
    opts.forEach(function (val) {
      radios.forEach(function (radio) {
        if (normalizeOptionText(radio.value) === normalizeOptionText(val) || String(radio.value) === String(val)) {
          radio.checked = true;
        }
      });
    });

    // Pin ATC ids immediately (do not wait for Dawn section fetch).
    if (variant.id != null) setIdInput(variant.id);

    var ids = collectSelectedOptionValueIds();
    var trigger = selects[selects.length - 1] || radios.filter(function (r) { return r.checked; })[0];

    // Drive Dawn with explicit option_value ids from selectedOptions (avoids attribute-query races).
    if (trigger && ids.length && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.optionValueSelectionChange) {
      var targetEl = trigger.tagName === 'SELECT' ? (trigger.selectedOptions[0] || trigger) : trigger;
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event: { target: trigger },
          target: targetEl,
          selectedOptionValues: ids
        }
      });
      return;
    }

    if (trigger) {
      trigger.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function setModelSelect(variantId) {
    var sel = modelSelect();
    if (!sel) return;
    var id = variantId != null ? String(variantId) : '';
    if (pinnedVariantId && id && id !== pinnedVariantId) {
      id = pinnedVariantId;
    }
    if (!id) return;
    syncing = true;
    setSelectValue(sel, id);
    syncing = false;
  }

  function updateShippingVariant(variantId) {
    qsa('.hh-ship-est').forEach(function (root) {
      if (variantId) root.setAttribute('data-variant', String(variantId));
    });
  }

  function updatePreorderButton(variant) {
    var btn = qs('.product-form__submit');
    if (!btn) return;
    var span = qs('span', btn);
    if (!span) return;
    if (isPreorder(variant)) {
      btn.removeAttribute('disabled');
      btn.setAttribute('data-hh-preorder', 'true');
      span.textContent = PREORDER_LABEL;
      var idInput = qs('input.product-variant-id');
      if (idInput) idInput.disabled = false;
    } else if (variant && variant.available) {
      btn.removeAttribute('data-hh-preorder');
      btn.removeAttribute('disabled');
      span.textContent = 'Add to cart';
      var idInput2 = qs('input.product-variant-id');
      if (idInput2) idInput2.disabled = false;
    }
  }

  /* === HH_24_MANIFOLD_NOTE start (temporary; remove with snippets/hh-24-manifold-note.liquid) === */
  /** True when variant is a 24″ width GR/TGR (24GR* / 24TGR*), not depth *24TD. */
  function is24ManifoldSize(variant) {
    if (!variant) return false;
    var sku = String(variant.sku || '');
    if (/^24T?GR/i.test(sku)) return true;
    var parts = [variant.title];
    if (variant.options && variant.options.length) parts = parts.concat(variant.options);
    var blob = parts.filter(Boolean).join(' ');
    return /\b24T?GR(?=[A-Z0-9]|\b)/i.test(blob);
  }

  function update24ManifoldNote(variant) {
    var note = qs('[data-hh-24-manifold-note]');
    if (!note) return;
    var show = is24ManifoldSize(variant);
    if (!show) {
      var sel = modelSelect();
      var opt = sel && sel.selectedOptions && sel.selectedOptions[0];
      if (opt) {
        show = /\b24T?GR(?=[A-Z0-9]|\b)/i.test(normalizeOptionText(opt.textContent));
      }
    }
    if (show) {
      note.hidden = false;
      note.setAttribute('aria-hidden', 'false');
    } else {
      note.hidden = true;
      note.setAttribute('aria-hidden', 'true');
    }
  }
  /* === HH_24_MANIFOLD_NOTE end === */

  function isTgrFamily(handle) {
    return String(handle || '').toLowerCase().indexOf('tgr') !== -1;
  }

  /** Straight GR only (not TGR/DGR). */
  function isStraightGrFamily(handle) {
    var h = String(handle || '').toLowerCase();
    if (!h) return false;
    if (h.indexOf('tgr') !== -1 || h.indexOf('dgr') !== -1) return false;
    if (/^\d*gr$/.test(h)) return true;
    if (/(?:^|-)(?:\d+)?gr(?:$|-)/.test(h)) return true;
    if (/\dgr(?:$|-)/.test(h)) return true;
    return false;
  }

  /** Straight GR / non-TGR: single catalog w must fit ≤ front and ≤ rear. */
  function widthFits(dim, frontW, rearW) {
    if (dim.frontW != null || dim.rearW != null) {
      if (dim.frontW != null && dim.frontW > frontW) return false;
      if (dim.rearW != null && dim.rearW > rearW) return false;
      // If only one of front/rear on product, also gate single w if present
      if (dim.frontW == null && dim.w != null && dim.w > frontW) return false;
      if (dim.rearW == null && dim.w != null && dim.w > rearW) return false;
      return true;
    }
    if (dim.w == null) return false;
    // Single catalog width must fit both customer widths (≤ front and ≤ rear)
    return dim.w <= frontW && dim.w <= rearW;
  }

  /**
   * TGR gold width fit (2026-09-19).
   * Physical taper titles (frontW/rearW): grate front ≤ cust front, grate rear ≤ cust rear.
   * Single catalog w: strict gold w ≤ front AND w > rear; soft=true allows w ≤ front && w ≤ rear.
   */
  function widthFitsTgr(dim, frontW, rearW, soft) {
    if (dim.frontW != null || dim.rearW != null) {
      if (dim.frontW != null && dim.frontW > frontW) return false;
      if (dim.rearW != null && dim.rearW > rearW) return false;
      if (dim.frontW == null && dim.w != null && dim.w > frontW) return false;
      if (dim.rearW == null && dim.w != null && dim.w > rearW) return false;
      return true;
    }
    if (dim.w == null) return false;
    if (soft) return dim.w <= frontW && dim.w <= rearW;
    return dim.w <= frontW && dim.w > rearW;
  }

  function depthFits(dim, deepBottom, deepTop, useDeepTop) {
    // DS-style range: catalog needs firebox deep enough for max span
    if (dim.dMin != null || dim.dMax != null) {
      var need = dim.dMax != null ? dim.dMax : dim.dMin;
      if (need != null && need > deepBottom) return false;
      if (useDeepTop && deepTop != null && need != null && need > deepTop) return false;
      if (dim.dMin != null && dim.dMin > deepBottom) return false;
      return true;
    }
    var vd = dim.d;
    if (vd == null && dim.h != null) vd = dim.h;
    if (vd == null) return true;
    if (vd > deepBottom) return false;
    if (useDeepTop && deepTop != null && vd > deepTop) return false;
    return true;
  }

  function scoreDim(dim) {
    var fw = dim.frontW != null ? dim.frontW : 0;
    var rw = dim.rearW != null ? dim.rearW : (dim.w || 0);
    var ww = Math.max(fw, rw, dim.w || 0);
    var dd = dim.dMax != null ? dim.dMax : (dim.d != null ? dim.d : (dim.h || 0));
    return { w: ww, d: dd };
  }

  /**
   * Snap to largest catalog size that fits customer firebox dims.
   * useDeepTop=false for GR/TGR/DGR/1Q/2Q/3Q.
   * Optional 8th arg handle: when TGR, use trapezoid width gold (+ soft fallback).
   */
  function pickBestFit(variants, frontW, rearW, openH, deepBottom, deepTop, useDeepTop, handle) {
    var tgr = isTgrFamily(handle);

    function tryPick(soft) {
      var best = null;
      (variants || []).forEach(function (v) {
        var dim = variantDims(v);
        var okW = tgr
          ? widthFitsTgr(dim, frontW, rearW, soft)
          : widthFits(dim, frontW, rearW);
        if (!okW) return;
        var vh = dim.h;
        var vd = dim.d;
        if (vh == null && vd != null) vh = vd;
        if (vd == null && vh != null) vd = vh;
        if (vh != null && vh > openH) return;
        if (!depthFits(dim, deepBottom, deepTop, useDeepTop)) return;
        if (!best) {
          best = { v: v, dim: dim };
          return;
        }
        var bs = scoreDim(best.dim);
        var cs = scoreDim(dim);
        // Prefer largest catalog front/w, then largest depth (under Deep Bottom gate above).
        if (cs.w > bs.w || (cs.w === bs.w && cs.d > bs.d)) best = { v: v, dim: dim };
      });
      return best;
    }

    if (tgr) {
      var strict = tryPick(false);
      if (strict) return strict;
      return tryPick(true);
    }
    return tryPick(false);
  }

  function isHthFamily(handle) {
    var h = String(handle || '').toLowerCase();
    return h === 'hth' || h === 'hth5';
  }

  /**
   * HTH/HTH5 model: {span}HTH{depth}D or {span}HTH5{depth}D (also Nw Nd titles).
   * span is tall when vertical, wide when horizontal.
   */
  function parseHthSpanDepth(text) {
    var s = String(text || '');
    var m = s.match(/(\d+(?:\.\d+)?)\s*HTH5?\s*(\d+(?:\.\d+)?)\s*D/i);
    if (m) return { span: +m[1], depth: +m[2] };
    m = s.match(/(\d+(?:\.\d+)?)\s*w\s+(\d+(?:\.\d+)?)\s*d/i);
    if (m) return { span: +m[1], depth: +m[2] };
    return null;
  }

  function hthShortLabel(variant) {
    if (!variant) return '';
    var t = String(variant.title || (variant.options && variant.options[0]) || '').replace(/\s+/g, ' ').trim();
    if (!t) return '';
    return t.split(' ')[0];
  }

  function hthVariantParsed(v) {
    var parts = [v.title, v.sku];
    if (v.options && v.options.length) parts = parts.concat(v.options);
    var parsed = parseHthSpanDepth(parts.filter(Boolean).join(' '));
    if (!parsed) return null;
    return { v: v, span: parsed.span, depth: parsed.depth };
  }

  function hthIsReady(v) {
    if (!v) return false;
    var qty = v.inventory_quantity;
    var qtyN = qty == null || qty === '' ? null : Number(qty);
    if (qtyN != null && qtyN > 0) return true;
    if ((v.availableForSale === true || v.available === true) && (qtyN == null || qtyN > 0)) return true;
    return false;
  }

  /** Prefer larger span, then larger depth; on ties prefer in-stock / available. */
  function hthBetter(cand, best) {
    if (!best) return true;
    if (cand.span > best.span) return true;
    if (cand.span < best.span) return false;
    if (cand.depth > best.depth) return true;
    if (cand.depth < best.depth) return false;
    var cr = hthIsReady(cand.v);
    var br = hthIsReady(best.v);
    if (cr && !br) return true;
    return false;
  }

  /**
   * Dual-orientation HTH gold fit (2026-09-19).
   * Vertical: span=tall ≤ openH; depth ≤ min(deepBottom, deepTop).
   * Horizontal: span=wide ≤ min(frontW, rearW); depth ≤ deepBottom only.
   * Multi: 2× smallest catalog span that pairs under usable width.
   */
  function pickBestHthFit(variants, frontW, rearW, openH, deepBottom, deepTop) {
    var usableW = Math.min(frontW, rearW);
    var consDepth = deepTop != null ? Math.min(deepBottom, deepTop) : deepBottom;
    var bestVertical = null;
    var bestHorizontal = null;
    var parsedList = [];

    (variants || []).forEach(function (v) {
      var meta = hthVariantParsed(v);
      if (!meta) return;
      parsedList.push(meta);
      if (meta.span <= openH && meta.depth <= consDepth) {
        if (hthBetter(meta, bestVertical)) bestVertical = meta;
      }
      if (meta.span <= usableW && meta.depth <= deepBottom) {
        if (hthBetter(meta, bestHorizontal)) bestHorizontal = meta;
      }
    });

    // Prefer smallest catalog span that pairs as 2× under usableW (typically 8).
    var multiHorizontal = null;
    var multiBest = null;
    parsedList.forEach(function (meta) {
      if (meta.depth > deepBottom) return;
      if (2 * meta.span > usableW) return;
      if (!multiBest) {
        multiBest = meta;
        return;
      }
      if (meta.span < multiBest.span) {
        multiBest = meta;
        return;
      }
      if (meta.span > multiBest.span) return;
      if (meta.depth > multiBest.depth) {
        multiBest = meta;
        return;
      }
      if (meta.depth < multiBest.depth) return;
      if (hthIsReady(meta.v) && !hthIsReady(multiBest.v)) multiBest = meta;
    });
    if (multiBest) {
      multiHorizontal = { count: 2, v: multiBest.v, span: multiBest.span, depth: multiBest.depth };
    }

    return {
      bestVertical: bestVertical,
      bestHorizontal: bestHorizontal,
      multiHorizontal: multiHorizontal
    };
  }

  function formatHthFitStatus(fit) {
    if (!fit) return NO_FIT;
    var parts = [];
    if (fit.bestVertical) {
      parts.push('vertical ' + hthShortLabel(fit.bestVertical.v));
    }
    if (fit.bestHorizontal) {
      var h = 'horizontal ' + hthShortLabel(fit.bestHorizontal.v);
      if (fit.multiHorizontal) {
        h += ' (or ' + fit.multiHorizontal.count + '\u00d7' + hthShortLabel(fit.multiHorizontal.v) + ')';
      }
      parts.push(h);
    } else if (fit.multiHorizontal) {
      parts.push('horizontal ' + fit.multiHorizontal.count + '\u00d7' + hthShortLabel(fit.multiHorizontal.v));
    }
    if (!parts.length) return NO_FIT;
    return 'Best fit: ' + parts.join('; ');
  }

  function setDeepTopUi(root, skip) {
    var wrap = qs('[data-hh-deep-top]', root) || qs('#hh-measure-deep-top-wrap', root);
    var input = qs('#hh-measure-deep-top', root);
    var na = qs('.hh-measure__na', wrap || root);
    if (input) {
      if (skip) {
        input.setAttribute('disabled', 'disabled');
        input.value = '';
        input.setAttribute('placeholder', 'N/A');
      } else {
        input.removeAttribute('disabled');
        input.removeAttribute('placeholder');
      }
    }
    if (wrap) {
      if (skip) wrap.classList.add('hh-measure__field--na');
      else wrap.classList.remove('hh-measure__field--na');
    }
    if (na) {
      na.hidden = !skip;
      na.textContent = skip ? 'N/A (tubes lean forward)' : '';
    }
  }

  function formatFitLabel(variant) {
    if (!variant) return '';
    var t = variant.title || (variant.options && variant.options[0]) || '';
    return String(t).replace(/\s+/g, ' ').trim();
  }

  function applyFit(root) {
    var status = qs('#hh-measure-status', root) || qs('#hh-measure-status');
    function setStatus(msg) {
      if (status) status.textContent = msg || '';
    }
    var handle = (root.getAttribute('data-handle') || '').toLowerCase();
    if (handle === 'cfi') {
      setStatus('Custom size — contact us for a CFI. Don’t pick a stock model from these numbers.');
      return;
    }
    var hth = isHthFamily(handle);
    // HTH uses Deep Top (conservative depth); never skipDeepTop for hth/hth5.
    var skipTop = hth ? false : skipsDeepTop(handle);
    setDeepTopUi(root, skipTop);

    var frontW = parseNum((qs('#hh-measure-front-width', root) || {}).value);
    var rearW = parseNum((qs('#hh-measure-rear-width', root) || {}).value);
    var openH = parseNum((qs('#hh-measure-opening-tall', root) || {}).value);
    var deepBottom = parseNum((qs('#hh-measure-deep-bottom', root) || {}).value);
    var deepTop = parseNum((qs('#hh-measure-deep-top', root) || {}).value);

    if (frontW == null || rearW == null || openH == null || deepBottom == null) {
      setStatus('');
      return;
    }
    if (!skipTop && deepTop == null) {
      setStatus('');
      return;
    }

    var variants = loadVariants(root);

    if (hth) {
      var hthFit = pickBestHthFit(variants, frontW, rearW, openH, deepBottom, deepTop);
      var statusMsg = formatHthFitStatus(hthFit);
      setStatus(statusMsg);
      if (statusMsg === NO_FIT) return;
      var snap = (hthFit.bestVertical && hthFit.bestVertical.v)
        || (hthFit.bestHorizontal && hthFit.bestHorizontal.v)
        || null;
      if (snap) {
        pinnedVariantId = String(snap.id);
        setModelSelect(snap.id);
        setIdInput(snap.id);
        syncDawnOptions(snap);
        updateShippingVariant(snap.id);
        updatePreorderButton(snap);
        update24ManifoldNote(snap);
      }
      return;
    }

    var fit = pickBestFit(variants, frontW, rearW, openH, deepBottom, deepTop, !skipTop, handle);
    if (!fit) {
      setStatus(NO_FIT);
      return;
    }
    var msg = 'Best fit: ' + formatFitLabel(fit.v);
    if (frontW > rearW) {
      if (isTgrFamily(handle)) {
        msg += ' — ' + TGR_TRAP_NOTE;
      } else if (isStraightGrFamily(handle)) {
        msg += ' — ' + GR_TGR_HINT;
      }
    }
    setStatus(msg);
    pinnedVariantId = String(fit.v.id);
    setModelSelect(fit.v.id);
    setIdInput(fit.v.id);
    syncDawnOptions(fit.v);
    updateShippingVariant(fit.v.id);
    updatePreorderButton(fit.v);
    update24ManifoldNote(fit.v);
  }

  var MEASURE_INPUTS = [
    '#hh-measure-front-width',
    '#hh-measure-rear-width',
    '#hh-measure-opening-tall',
    '#hh-measure-deep-bottom',
    '#hh-measure-deep-top'
  ];

  function bindMeasure(root) {
    if (!root || root.getAttribute('data-hh-bound')) return;
    root.setAttribute('data-hh-bound', '1');
    var handle = (root.getAttribute('data-handle') || '').toLowerCase();
    setDeepTopUi(root, skipsDeepTop(handle));
    MEASURE_INPUTS.forEach(function (sel) {
      var el = qs(sel, root) || qs(sel);
      if (!el) return;
      el.addEventListener('input', function () {
        applyFit(root);
      });
      el.addEventListener('change', function () {
        applyFit(root);
      });
    });
    var fw = qs('#hh-measure-front-width', root);
    var rw = qs('#hh-measure-rear-width', root);
    var oh = qs('#hh-measure-opening-tall', root);
    var db = qs('#hh-measure-deep-bottom', root);
    if (fw && rw && oh && db && fw.value && rw.value && oh.value && db.value) applyFit(root);
  }

  function onModelSelectChange(sel) {
    if (!sel || syncing) return;
    var id = sel.value;
    pinnedVariantId = id ? String(id) : null;
    // Re-assert selected attrs/index so Dawn section HTML cannot bounce the visible menu.
    syncing = true;
    setSelectValue(sel, String(id));
    syncing = false;

    var root = qs('.hh-measure');
    var variant = findVariantById(loadVariants(root), id);
    var opt = sel.selectedOptions && sel.selectedOptions[0];
    if (!variant) {
      // Never fall back to current Dawn select values (still default) — that causes bounce.
      var label = opt ? normalizeOptionText(opt.textContent) : '';
      variant = {
        id: id,
        options: label ? [label] : [],
        title: label,
        available: opt && opt.getAttribute('data-available') === 'true',
        inventory_policy: opt && opt.getAttribute('data-inventory-policy'),
        inventory_quantity: opt && Number(opt.getAttribute('data-inventory-quantity'))
      };
    }
    setIdInput(id);
    syncDawnOptions(variant);
    updateShippingVariant(id);
    updatePreorderButton(variant);
    update24ManifoldNote(variant);
  }

  function bindModelSelect() {
    // Event delegation survives Dawn replacing variant-selects / select nodes.
    if (document.documentElement.getAttribute('data-hh-model-delegated')) return;
    document.documentElement.setAttribute('data-hh-model-delegated', '1');
    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t || !t.classList) return;
        if (!(t.classList.contains('hh-model-select') || t.classList.contains('model'))) return;
        if (t.tagName !== 'SELECT') return;
        onModelSelectChange(t);
      },
      false
    );
  }

  function onIdChange(e) {
    var t = e.target;
    if (!t || (t.name !== 'id' && !(t.classList && t.classList.contains('product-variant-id')))) return;
    if (pinnedVariantId && String(t.value) !== pinnedVariantId) {
      t.value = pinnedVariantId;
      syncShips();
      updateShippingVariant(pinnedVariantId);
      setModelSelect(pinnedVariantId);
      var pinned = findVariantById(loadVariants(qs('.hh-measure')), pinnedVariantId);
      if (pinned) {
        updatePreorderButton(pinned);
        update24ManifoldNote(pinned);
      }
      return;
    }
    if (!t.value) return;
    updateShippingVariant(t.value);
    var variant = findVariantById(loadVariants(qs('.hh-measure')), t.value);
    if (variant) {
      setModelSelect(variant.id);
      updatePreorderButton(variant);
      update24ManifoldNote(variant);
    }
  }

  function bindPubSub() {
    if (typeof subscribe !== 'function') return;
    var evName = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) || 'variant-change';
    try {
      subscribe(evName, function (payload) {
        var variant = payload && payload.data && payload.data.variant;
        if (!variant) return;
        var list = loadVariants(qs('.hh-measure'));
        if (pinnedVariantId && String(variant.id) !== pinnedVariantId) {
          // Wrong section resolve — keep menu/id on pin; do not re-fetch (avoids loops).
          setIdInput(pinnedVariantId);
          setModelSelect(pinnedVariantId);
          updateShippingVariant(pinnedVariantId);
          var pinned = findVariantById(list, pinnedVariantId);
          if (pinned) {
            updatePreorderButton(pinned);
            update24ManifoldNote(pinned);
          }
          return;
        }
        updateShippingVariant(variant.id);
        setModelSelect(variant.id);
        var resolved = findVariantById(list, variant.id) || variant;
        updatePreorderButton(resolved);
        update24ManifoldNote(resolved);
      });
    } catch (err) {}
  }

  function init() {
    bindModelSelect();
    qsa('.hh-measure').forEach(bindMeasure);
    document.addEventListener('change', onIdChange);
    bindPubSub();
    /* HH_24_MANIFOLD_NOTE: sync visibility for selected / URL variant */
    (function sync24ManifoldNoteOnInit() {
      var sel = modelSelect();
      var id = sel && sel.value;
      var variant = id ? findVariantById(loadVariants(qs('.hh-measure')), id) : null;
      if (!variant && sel && sel.selectedOptions && sel.selectedOptions[0]) {
        variant = { title: normalizeOptionText(sel.selectedOptions[0].textContent), sku: '' };
      }
      update24ManifoldNote(variant);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for quick console QA on PDP
  window.__hhFit = {
    parseDims: parseDims,
    pickBestFit: pickBestFit,
    skipsDeepTop: skipsDeepTop,
    isTgrFamily: isTgrFamily,
    isStraightGrFamily: isStraightGrFamily,
    widthFits: widthFits,
    widthFitsTgr: widthFitsTgr,
    isHthFamily: isHthFamily,
    parseHthSpanDepth: parseHthSpanDepth,
    pickBestHthFit: pickBestHthFit,
    formatHthFitStatus: formatHthFitStatus,
    hthShortLabel: hthShortLabel,
    TGR_COLLECTION_PATH: TGR_COLLECTION_PATH,
    TGR_TRAP_NOTE: TGR_TRAP_NOTE,
    GR_TGR_HINT: GR_TGR_HINT,
    is24ManifoldSize: is24ManifoldSize,
    update24ManifoldNote: update24ManifoldNote
  };
})();
